import "./PercentProgressBarComp.css";
import { defineComponent as y, ref as f, computed as s, watch as P, openBlock as a, createElementBlock as o, normalizeStyle as n, toDisplayString as p, createCommentVNode as i, createElementVNode as u } from "vue";
import { _ as B } from "./_plugin-vue_export-helper.dad06003.js";
const w = {
  key: 0,
  class: "percentProgressBar__percent"
}, x = {
  key: 0,
  class: "percentProgressBar__trackPercent"
}, k = /* @__PURE__ */ y({
  __name: "PercentProgressBarComp",
  props: {
    progress: { default: 0 },
    height: { default: 20 },
    widthFull: { type: Boolean, default: !1 },
    width: { default: 400 },
    min: { default: 0 },
    max: { default: 100 },
    percentOutside: { type: Boolean, default: !1 }
  },
  setup(d) {
    const e = d, t = f(e.progress), c = s(() => g(e.progress, e.min, e.max)), _ = s(() => ({
      height: `${e.height}px`,
      width: e.widthFull ? "100%" : `${e.width + (e.percentOutside ? 30 : 0)}px`
    })), m = s(() => ({
      height: `${e.height}px`
    })), h = s(() => ({
      width: `${t.value}%`
    })), g = (r, l, v) => Math.min(Math.max(r, l), v);
    return P(
      () => e.progress,
      async () => {
        for (; t.value !== c.value; )
          t.value += c.value < t.value ? -1 : 1, await new Promise((r) => setTimeout(r, 5));
      }
    ), (r, l) => (a(), o("div", {
      class: "percentProgressBar",
      style: n(_.value)
    }, [
      e.percentOutside ? (a(), o("p", w, p(t.value) + "% ", 1)) : i("", !0),
      u("div", {
        class: "percentProgressBar__bar",
        style: n(m.value)
      }, [
        u("div", {
          class: "percentProgressBar__track",
          style: n(h.value)
        }, [
          e.percentOutside ? i("", !0) : (a(), o("p", x, p(t.value) + "% ", 1))
        ], 4)
      ], 4)
    ], 4));
  }
});
const O = /* @__PURE__ */ B(k, [["__scopeId", "data-v-db409482"]]);
export {
  O as PercentProgressBarComp
};
//# sourceMappingURL=PercentProgressBarComp.js.map
